import { BatchResult } from './batch-result';
import { CoordinatorService } from './coordinator.service';

export class BatchResultEmpty {
    constructor(
        private coords: CoordinatorService,
        parent: BatchResult,
    ) {}

    html() {
        return this.coords.text('noData');
    }
}
